import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './theme.css';

if (typeof window !== 'undefined' && !window.__authFetchWrapped) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const headers = new Headers(init.headers || {});
    const token = window.localStorage.getItem('authToken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return originalFetch(input, { ...init, headers });
  };
  window.__authFetchWrapped = true;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
